import React from 'react';
import sprintf from 'sprintf';

class SMFeatureListTableRow extends React.Component {
  
  constructor(props) {
    super(props);
  }
  
  componentDidMount() {
  }
  
  render() {
    const feature = this.props.feature;
    return(
      <div className="col-sm-12 col-md-4 matome-box">
        <a href={Routes.feature_path(feature.uid)}>
          <div className="matome-linkbox">
            <img src={feature.image} alt={sprintf("%s", feature.title)} className="is-hover" />
            <h2 className="matome-subtitle">{feature.title}</h2>
          </div>
        </a>
        <p className="js-line-camp-2 matome-description">{feature.description}</p>
      </div>
    );
  }
  
}
export default SMFeatureListTableRow;



// WEBPACK FOOTER //
// ./app/javascript/components/features/SMFeatureListTableRow.jsx